import { useEffect, useState } from "react";
import Header from "./header/header"
import Footer from "./footer/footer"
import dynamic from "next/dynamic";
import LazyWrapper from "@/components/LazyWrapper";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// const Header = dynamic(() => import('./header/header'), {
//   ssr: false,
// });
// const Footer = dynamic(() => import('./footer/footer'), {
//   ssr: false,
// });


const Layout = (props) => {

  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    // Trigger after first render
    setTimeout(()=>{
      setShowFooter(true);
    },2000)
    
  }, []);

  return (
    <>

      <Header />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <main>
        {props.children}
      </main>
      <LazyWrapper>
        {showFooter && <Footer />}
      </LazyWrapper>
    </>
  )
}

export default Layout